import React from 'react';
import styles from './TopBar.module.css';
import { useCPOContext } from '../contexts/CPOContext';

export default function TopBar({ onReset }) {
  const { puntos, cpcCursadas, resetCPO } = useCPOContext();
  return (
    <div className={styles.topbar}>
      <div className={styles.title}>PLAN ABOGACÍA 2004</div>
      <div className={styles.stats}>
        <span className={styles.badge}>CPC Cursadas: {cpcCursadas}/14</span>
        <span className={styles.badge}>Puntos CPO: {puntos?.total || 0}/69</span>
        <button
          className={styles.reset}
          onClick={() => {
            if (window.confirm('¿Reiniciar todo el progreso? Esta acción no se puede deshacer.')) {
              // Limpiar progreso CPO persistido y luego reiniciar progreso global
              resetCPO();
              onReset();
            }
          }}
        >
          Reiniciar Progreso
        </button>
      </div>
    </div>
  );
}


